import api from '../service/api.service';

import { PaginationQueryParams } from '../../types';
import { parseQueryFilters } from '../../helpers/parseQueryFilters';

const BASE_URL = '/v1';
const BASE_URL_NEW = 'v1/fo';
const accountingSystem = localStorage.getItem('accountingSystem');

interface FirmWithdrawFundsBody {
  toUnrestrictedAccountId: number;
  amount: number;
  fromSystemAccountType: 'REV' | 'EXP' | 'LIEN';
}

export const getFirmsList = async ({
  size,
  page,
  count,
  match,
  filters,
}: PaginationQueryParams) => {
  const queryFilters = parseQueryFilters(filters);
  const targetUrl = `${BASE_URL}/firms?size=${size}&page=${page}&count=${count}&match=${
    match || ''
  }${queryFilters || ''}`;

  return await api.get(targetUrl);
};

export const createFirmRecord = async (data: unknown) => {
  const targetUrl = `${BASE_URL}/firms`;

  return await api.post(targetUrl, data);
};

export const getFirmRecord = async (firmId: string) => {
  const targetUrl = `${BASE_URL}/firms/${firmId}`;

  return await api.get(targetUrl);
};

export const updateFirmRecord = async (firmId: string, data: unknown) => {
  const targetUrl = `${BASE_URL}/firms/${firmId}`;

  return await api.put(targetUrl, data);
};

export const getFirmBankingInfo = async (firmId: string) => {
  const targetUrl = `${BASE_URL}/firms/${Number(firmId)}/banking`;

  return await api.get(targetUrl);
};

export const withdrawFirmFunds = async (
  pin: string,
  data: FirmWithdrawFundsBody,
) => {
  const targetUrl = `${BASE_URL_NEW}/banking/withdrawals`;

  return await api.post<void>(targetUrl, data, {
    headers: { 'x-pin': pin },
  });
};

export const setFirmExternalVendorId = async (firmId: number, externalVendorId: string) => {
  const targetUrl = `${BASE_URL}/firms/${firmId}/${accountingSystem}/accounting-party-id`;
  return await api.put<{
    message?: string;
    success?: boolean;
    isSynced: boolean;
    status: string;
    externalVendorId: string | null;
    lastSyncedAt: string | null;
    link: string | null;
  }>(targetUrl, { externalVendorId });
};

export const removeFirmExternalVendorId = async (firmId: number) => {
  const targetUrl = `${BASE_URL}/firms/${firmId}/${accountingSystem}/accounting-party-id`;
  return await api.delete<{ message: string; success: boolean }>(targetUrl);
};

